import React from 'react';
import { Search } from 'lucide-react';

interface ScreenFiltersProps {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    selectedType: 'all' | number;
    onTypeChange: (value: 'all' | number) => void;
    descriptionFilter: 'all' | 'with' | 'without';
    onDescriptionFilterChange: (value: 'all' | 'with' | 'without') => void;
    productsFilter: 'all' | 'with' | 'without';
    onProductsFilterChange: (value: 'all' | 'with' | 'without') => void;
    selectedCategory: 'all' | string;
    onCategoryChange: (value: 'all' | string) => void;
    categoriasDisponiveis: string[];
    loading?: boolean;
}

export const ScreenFilters: React.FC<ScreenFiltersProps> = ({
    searchTerm,
    onSearchChange,
    selectedType,
    onTypeChange,
    descriptionFilter,
    onDescriptionFilterChange,
    productsFilter,
    onProductsFilterChange,
    selectedCategory,
    onCategoryChange,
    categoriasDisponiveis,
    loading = false
}) => {
    const isDisabled = loading;

    return (
        <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm mb-4 sm:mb-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
                {/* Search - Nome */}
                <div className="relative sm:col-span-2 lg:col-span-1">
                    <input
                        type="text"
                        placeholder="Buscar por nome..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        disabled={isDisabled}
                        className={`w-full pl-9 sm:pl-10 pr-3 sm:pr-4 py-2 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : ''
                            }`}
                    />
                    <Search size={18} className="absolute left-2.5 sm:left-3 top-2.5 sm:top-2.5 text-gray-400 sm:w-[20px] sm:h-[20px]" />
                </div>

                {/* Categoria Filter */}
                <select
                    value={selectedCategory}
                    onChange={(e) => onCategoryChange(e.target.value === 'all' ? 'all' : e.target.value)}
                    disabled={isDisabled}
                    className={`w-full px-3 sm:px-4 py-2 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                >
                    <option value="all">Categoria: Todas</option>
                    {categoriasDisponiveis.map((cat) => (
                        <option key={cat} value={cat}>
                            {cat}
                        </option>
                    ))}
                </select>

                {/* Tipo Filter */}
                <select
                    value={selectedType}
                    onChange={(e) => onTypeChange(e.target.value === 'all' ? 'all' : Number(e.target.value))}
                    disabled={isDisabled}
                    className={`w-full px-3 sm:px-4 py-2 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                >
                    <option value="all">Todos os tipos</option>
                    <option value={0}>Lista com Colunas</option>
                    <option value={1}>Panfleto</option>
                    <option value={2}>Vídeo</option>
                </select>

                {/* Descrição Filter */}
                <select
                    value={descriptionFilter}
                    onChange={(e) => onDescriptionFilterChange(e.target.value as 'all' | 'with' | 'without')}
                    disabled={isDisabled}
                    className={`w-full px-3 sm:px-4 py-2 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                >
                    <option value="all">Descrição: Todas</option>
                    <option value="with">Descrição: Com</option>
                    <option value="without">Descrição: Sem</option>
                </select>

                {/* Produtos Filter */}
                <select
                    value={productsFilter}
                    onChange={(e) => onProductsFilterChange(e.target.value as 'all' | 'with' | 'without')}
                    disabled={isDisabled}
                    className={`w-full px-3 sm:px-4 py-2 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                >
                    <option value="all">Produtos: Todos</option>
                    <option value="with">Produtos: Com</option>
                    <option value="without">Produtos: Sem</option>
                </select>
            </div>
        </div>
    );
};

